<template>
  <div id="testimonialFour"></div>
</template>

<script>
export default {
  name: "TestimonialFour",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        quote: "This product completely transformed how we work. The results speak for themselves.",
        name: "Sarah Johnson",
        role: "Head of Marketing",
        company: "TechCorp Inc.",
        rating: 5,
        chip: "Customer Story",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("testimonialFour");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const quoteSize = exporting ? 44 : 44 * this.scale;
      const nameSize = exporting ? 28 : 28 * this.scale;
      const roleSize = exporting ? 22 : 22 * this.scale;
      const logoHeight = exporting ? 42 : 42 * this.scale;
      const chipSize = exporting ? 22 : 22 * this.scale;
      const starSize = exporting ? 26 : 26 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";

      const rating = this.data.rating || 5;
      const starsHtml = Array(5).fill(0).map((_, i) => `
        <span style="color: ${i < rating ? '#fbbf24' : 'rgba(61, 35, 20, 0.2)'}; font-size: ${starSize}px;">★</span>
      `).join('');

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background: linear-gradient(145deg, #fff5eb 0%, #ffecd2 25%, #fcb69f 50%, #ee9ca7 75%, #ffdde1 100%);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Noise texture overlay -->
          <div style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0.4;
            background-image: url('data:image/svg+xml,%3Csvg viewBox=%220 0 256 256%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noise%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%224%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noise)%22/%3E%3C/svg%3E');
            pointer-events: none;
          "></div>

          <!-- Header with logo -->
          <div style="padding: 10%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <!-- Testimonial content - centered -->
          <div style="
            padding: 0 10%;
            position: relative;
            z-index: 1;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
          ">
            <div style="margin-bottom: 24px;">${starsHtml}</div>
            
            <div style="
              font-size: ${quoteSize}px;
              font-weight: 500;
              color: #3d2314;
              line-height: 1.4;
              margin-bottom: 40px;
            ">"${this.data.quote}"</div>

            <div style="text-align: center;">
              <p style="
                color: #3d2314;
                font-size: ${nameSize}px;
                margin: 0;
                font-weight: 700;
              ">
                ${this.data.name}
              </p>
              <p style="
                color: #6b4423;
                font-size: ${roleSize}px;
                margin: 8px 0 0 0;
                opacity: 0.8;
              ">${this.data.role}${this.data.company ? ` at ${this.data.company}` : ''}</p>
            </div>
          </div>

          <!-- Footer with chip -->
          <div style="padding: 10%; position: relative; z-index: 1; display: flex; justify-content: center;">
            <span
              style="
                display: inline-block;
                background: rgba(255, 255, 255, 0.6);
                backdrop-filter: blur(8px);
                color: #3d2314;
                font-size: ${chipSize}px;
                font-weight: 600;
                border-radius: 999px;
                padding: 14px 28px;
                letter-spacing: 0.02em;
                box-shadow: 0 4px 20px rgba(61, 35, 20, 0.1);
              "
            >
              ${this.data.chip}
            </span>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped>
</style>

